import React from 'react';
import { Footprints, DrumIcon, FileWarning, Car, Train, Bike} from 'lucide-react';
import { workshops } from '../../constants/workshops';

// Sample workshop data - you can move this to your constants/content.js file


// Helper function to determine the experience level color
const getExperienceLevelColor = (level) => {
  switch(level) {
    case 'Open to all':
      return 'bg-green-100 text-green-800';
    case 'Intermediate':
      return 'bg-blue-100 text-blue-800';
    case 'Advanced':
      return 'bg-purple-100 text-purple-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

// Workshop type icons and colors
const getWorkshopTypeIcon = (type) => {
  switch(type) {
    case 'Drumming':
      return <DrumIcon className="h-4 w-4" />;
    case 'Dancing':
      return <Footprints className="h-4 w-4" />;
    default:
      return null;
  }
};

// Helper function to determine the workshop type color
const getWorkshopTypeColor = (type) => {
  switch(type) {
    case 'Drumming':
      return 'bg-primary-yellow text-primary-purple';
    case 'Dancing':
      return 'bg-primary-orange text-white';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

const Workshops = () => {
  return (
    <section id="workshops" className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
      <div className="bg-white border-l-4 border-[#2E0854] rounded-lg shadow-md p-6 my-8">
  <h3 className="flex items-center text-xl font-bold mb-3">
    <FileWarning className='text-primary-orange'/> Important Note about Workshops locations
  </h3>
  <p className="text-gray-800">
    Please note that workshops will be held at two different venues. 
    Travel times at off peak times: 
   </p>

    <ul className="space-y-3 text-gray-600">
      <li className="flex items-start">
        <span className="text-primary-orange mr-2">•</span>
        <Car/>: 7 minutes
      </li>
      <li className="flex items-start">
        <span className="text-primary-orange mr-2">•</span>
        <Train/>: 23-35 minutes
      </li>
      <li className="flex items-start">
        <span className="text-primary-orange mr-2">•</span>
        <Bike/>: 12 minutes
      </li>
      <li className="flex items-start">
        <span className="text-primary-orange mr-2">•</span>
        <Footprints/>: 36 minutes (2.6 Km)
      </li>
    </ul>
</div>
        {/* Workshop cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {workshops.map((workshop) => (
              <div 
              key={workshop.id} 
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full"
            >
              <div className="p-5 flex flex-col flex-grow">
                <h3 className="text-lg font-bold mb-3">{workshop.title}</h3>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${getExperienceLevelColor(workshop.experienceLevel)}`}>
                    {workshop.experienceLevel}
                  </span>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1 ${getWorkshopTypeColor(workshop.type)}`}>
                    {getWorkshopTypeIcon(workshop.type)}
                  </span>
                </div>
                
                <div className="space-y-2 text-sm mb-4">
                  <div>
                    <span className="font-medium block">Instructor:</span>
                    <span className="text-gray-700">{workshop.instructor}</span>
                  </div>
                  <div>
                    <span className="font-medium block">Duration:</span>
                    <span className="text-gray-700">{workshop.duration}</span>
                  </div>
                  <div>
                    <span className="font-medium block">Location:</span>
                    <span className="text-gray-700">{workshop.location}</span>
                  </div>
                  <div>
                    <span className="font-medium block">Prerequisites:</span>
                    <span className="text-gray-700">{workshop.prerequisites}</span>
                  </div>
                  <div>
                    <span className="font-medium block">Equipment:</span>
                    <span className="text-gray-700">{workshop.equipment}</span>
                  </div>
                </div>

                <a 
                  href={workshop.registrationUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-2 bg-gradient-to-r from-primary-yellow to-primary-orange text-white text-center font-semibold rounded-full hover:opacity-90 transition mt-auto"
                >
                  Register
                </a>
              </div>
            </div>
          ))}
        </div>
        

      </div>
    </section>
  );
};

export default Workshops;